module.exports = __webpack_public_path__ + "img/item-3.a3a893c.png";